<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmPopup key="popup"></p-confirmPopup>
<p-menu #menuContextuelItemCommande popup="popup" [model]="menuContextuelEntrees"></p-menu>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div *ngIf="modeStandard" class="flex align-items-center">
				<h5 class="m-0">Commandes - {{emplacement.nom}} ({{emplacement.code}})</h5>
				<app-bouton-favori [titrePage]="titrePagePrincipale" [type]="eTypeFavori"></app-bouton-favori>
			</div>

			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>

		</p-card>
	</div>
</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="mb-4">
				<h5 class="my-1">Items en commande</h5>
				<span class="text-500">Liste de tous les items de la commande de l'emplacement</span>
			</div>
			<div class="flex align-content-center justify-content-between gap-2 flex-wrap my-2">
				<div class="flex align-items-center flex-wrap gap-2">
					<span class="p-input-icon-left">
						<i class="pi pi-search"></i>
						<input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
							placeholder="Recherche..." />
					</span>
						<button *ngIf="estAutorise('precommande_modifier')" pButton pRipple icon="pi pi-plus" class="p-button-success" label="Ajouter"
						(click)="surAjoutItem()"></button>
				</div>
				<div>
					<p-button label="Rafraîchir" icon="pi pi-refresh" (click)="rafraichir()" outlined></p-button>
				</div>
			</div>
			<p-table #dt [value]="itemsCommande" [columns]="selectedColumns" dataKey="itemCommandeId" [(selection)]="selectionMultipleItemCommande"
				(onRowSelect)="surChangementSelection()" (onRowUnselect)="surChangementSelection()"
				rowGroupMode="subheader" 
        		groupRowsBy="indBrouillon" scrollable
				(onHeaderCheckboxToggle)="surChangementSelection()" autoLayout="true" sortMode="multiple" [multiSortMeta]="sortMeta"
				styleClass="p-datatable-striped" [rowHover]="true" [filterDelay]="0" responsiveLayout="stack"
				[globalFilterFields]="['item.numero','item.description','demandeur']">
				<ng-template pTemplate="header" let-columns>
					<tr>

						<th style="min-width: 3rem">
							<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
						</th>
						<th pSortableColumn="quantite">
							<div class="flex justify-content-between align-items-center">
								Qte
								<p-sortIcon field="quantiteDemande"></p-sortIcon>
								<p-columnFilter type="text" field="quantiteDemande" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th pSortableColumn="statut.nom">
							<div class="flex justify-content-between align-items-center">
								Statut
								<p-sortIcon field="statut.nom"></p-sortIcon>
								<p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
									[showOperator]="false" [showAddButton]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
											(onChange)="filter($event.value)" optionLabel="name">
											<ng-template let-option pTemplate="item">
												<div class="multiselect-representative-option">

													<span class="ml-1">{{option.nom}}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.numero">
							<div class="flex justify-content-between align-items-center">
								Numéro
								<p-sortIcon field="item.numero"></p-sortIcon>
								<p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.description">
							<div class="flex justify-content-between align-items-center">
								Description
								<p-sortIcon field="item.description"></p-sortIcon>
								<p-columnFilter type="text" field="item.description" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="demandeur.prenom">
							<div class="flex justify-content-between align-items-center">
								Demandeur
								<p-sortIcon field="demandeur.prenom"></p-sortIcon>
								<p-columnFilter type="text" field="demandeur.prenom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="dateDemande">
							<div class="flex justify-content-between align-items-center">
								Date d'ajout
								<p-sortIcon field="dateDemande"></p-sortIcon>
								<p-columnFilter type="text" field="dateDemande" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="dateRequis">
							<div class="flex justify-content-between align-items-center">
								Date réquis
								<p-sortIcon field="dateRequis"></p-sortIcon>
								<p-columnFilter type="text" field="dateRequis" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="codeProjet">
							<div class="flex justify-content-between align-items-center">
								Code projet
								<p-sortIcon field="codeProjet"></p-sortIcon>
								<p-columnFilter type="text" field="codeProjet" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="codeActivite">
							<div class="flex justify-content-between align-items-center">
								Code activité
								<p-sortIcon field="codeActivite"></p-sortIcon>
								<p-columnFilter type="text" field="codeActivite" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="note">
							<div class="flex justify-content-between align-items-center">
								Note
								<p-sortIcon field="note"></p-sortIcon>
								<p-columnFilter type="text" field="note" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th style="min-width: 8rem; width: 8rem;" pFrozenColumn alignFrozen="right"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="groupheader" let-item>
					<tr pRowGroupHeader>
						<td [attr.colspan]="12" class="text-center">
							<div class="flex align-items-center" style="height: 30px;">
								<div *ngIf="item.indBrouillon; else processingCommande" class="flex align-items-center gap-2">
									<span style="font-weight: bold; color: #e67e22;">
										Commandes en <b>Brouillon</b> (non envoyées).
									</span>
									<p-button *ngIf="estAutorise('precommande_envoyer_approbation')" icon="pi pi-fw pi-forward" text label="Envoyer tous en approbation" (onClick)="changerStatutTous(6)"></p-button>
								</div>
								<ng-template #processingCommande>
									<span style="font-weight: bold; color: #27ae60;">
										Commandes <b>en traitement</b>.
									</span>
								</ng-template>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>

					<tr [pContextMenuRow]="item">
						<td>
							<p-tableCheckbox [disabled]="item.statut.statutId != 3" [value]="item" [label]="isMobile ? 'Sélectionner' : null"></p-tableCheckbox>
						</td>
						<td *ngIf="item.indPrecommande" style="font-weight: bold;"><span class="p-column-title">Quantité</span>{{item.quantite}}</td>
						<td *ngIf="!item.indPrecommande">
							<span class="p-column-title">Quantité</span>
							<p-tag [style]="{whiteSpace: 'nowrap'}">{{item.quantite}} / {{item.quantiteDemande}}</p-tag>
						</td>
						<td *ngIf="item.statut.statutId == 4" style="font-weight: bold;"><span class="p-column-title">Quantité demandée</span>{{item.quantiteDemande}}</td>
						<td><span class="p-column-title">Statut</span><span [class]="'statut ' + item.statut.nom.replace(' ','').toLowerCase()">
								{{item.statut.nom}}
							</span>
						</td>

						<td><span class="p-column-title">Numéro</span>
							<div class="flex align-items-center gap-2">
								<div *ngIf="item.item.photoId">
									@defer (on viewport) {
									<app-image-loader [documentId]="item.item.photoId" [width]="40" [height]="40" [title]="item.item.numero"></app-image-loader>
									}
									@placeholder {
										<div class="flex align-items-center justify-content-center" style="height: 40px; width: 40px;">
											<p-skeleton width="40px" height="40px"></p-skeleton>
										</div>
									}
								</div>
								<span>{{item.item.numero}}</span>
							</div>
						</td>
						<td><span class="p-column-title">Description</span>{{item.item.description}}</td>
						<td><span class="p-column-title">Demandeur</span><app-employe-avec-emplacement [employe]="item.demandeur"></app-employe-avec-emplacement></td>
						<td><span class="p-column-title">Date de début</span>{{item.dateDemande | date:'yyyy-MM-dd'}}</td>
						<td [style.color]="isDateRequisExpired(item.dateRequis) ? 'red' : 'inherit'"><span class="p-column-title">Date réquis</span>{{item.dateRequis | date:'yyyy-MM-dd'}}</td>
						<td><span class="p-column-title">Code projet</span>{{item.codeProjet?.code}}</td>
                          <td><span class="p-column-title">Code activité</span>{{item.codeActivite?.code}}</td>
                          <td><span class="p-column-title">Note</span>{{item.note}}</td>
						<td pFrozenColumn alignFrozen="right">
							<div class="flex justify-content-end gap-1">
								<button *ngIf="item.statut.statutId == 3" pButton pRipple icon="pi pi-trash" class="p-button-danger boutonGrille"
									(click)="supprimerItemcommnde($event, item)"></button>
								<button *ngIf="item.statut.statutId == 3" pButton pRipple icon="pi pi-bars" class="p-button-secondary boutonGrille"
									(click)="surMenuContextuelItem($event, item)"></button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td [attr.colspan]="11">
							<div class="flex flex-column justify-content-center align-items-center gap-2 p-4">
								<i class="pi pi-info-circle text-2xl text-gray-500"></i>
								<span class="text-lg text-gray-500">Aucun item.</span>
								<small class="text-gray-500">
									Utilisez les filtres pour afficher les items.
								</small>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</p-card>
	</div>
</div>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="mb-4">
				<h5 class="my-1">Transports</h5>
				<span class="text-500">Liste de tous les transports de la commande de l'emplacement en cours</span>
			</div>
			<div class="flex align-content-center justify-content-between gap-2 flex-wrap my-2">
				<div class="flex align-items-center flex-wrap gap-2">
					<span class="p-input-icon-left">
						<i class="pi pi-search"></i>
						<input pInputText type="text" (input)="dtTransports.filterGlobal($event.target.value, 'contains')"
							placeholder="Recherche..." />
					</span>
					<p-button icon="pi pi-list" label="Liste complète" [routerLink]="['/transports']" [queryParams]="obtenirFiltresTransports()"></p-button>
					<span *ngIf="transportsCharges" class="text-500 text-sm">
						{{transports.length}} transport{{transports.length !== 1 ? 's' : ''}} trouvé{{transports.length !== 1 ? 's' : ''}}
					</span>
				</div>
				<div></div>
			</div>
			
			<div *ngIf="!transportsCharges" class="flex flex-column gap-2 my-2 text-center">
				<p-progressSpinner></p-progressSpinner>
			</div>
			<p-table *ngIf="transportsCharges" #dtTransports [value]="transports" dataKey="requisitionId" tableStyleClass="tableNormale"
				styleClass="p-datatable-sm p-datatable-striped" sortMode="multiple" [multiSortMeta]="sortMetaTransports"
				[rowHover]="true" [rows]="100" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
				[expandedRowKeys]="expandedRowsTransports"
				[globalFilterFields]="['numero','de.nom','a.nom','camion','remorque','chauffeur']">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th style="width: 3rem"></th>
						<th pSortableColumn="numero">
							<div class="flex justify-content-between align-items-center">
								Numéro
								<p-sortIcon field="numero"></p-sortIcon>
								<p-columnFilter type="numeric" field="numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="date">
							<div class="flex justify-content-between align-items-center">
								Date
								<p-sortIcon field="date"></p-sortIcon>
								<p-columnFilter type="date" field="date" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="type.nom">
							<div class="flex justify-content-between align-items-center">
								Type
								<p-sortIcon field="type.nom"></p-sortIcon>
								<p-columnFilter type="text" field="type.nom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="de.nom">
							<div class="flex justify-content-between align-items-center">
								De
								<p-sortIcon field="de.nom"></p-sortIcon>
								<p-columnFilter type="text" field="de.nom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="a.nom">
							<div class="flex justify-content-between align-items-center">
								A
								<p-sortIcon field="a.nom"></p-sortIcon>
								<p-columnFilter type="text" field="a.nom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="demandeur.prenomNom">
							<div class="flex justify-content-between align-items-center">
								Demandeur
								<p-sortIcon field="demandeur.prenomNom"></p-sortIcon>
								<p-columnFilter type="text" field="demandeur.prenomNom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="camion">
							<div class="flex justify-content-between align-items-center">
								Camion
								<p-sortIcon field="camion"></p-sortIcon>
								<p-columnFilter type="text" field="camion" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="remorque">
							<div class="flex justify-content-between align-items-center">
								Remorque
								<p-sortIcon field="remorque"></p-sortIcon>
								<p-columnFilter type="text" field="remorque" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="chauffeur">
							<div class="flex justify-content-between align-items-center">
								Chauffeur
								<p-sortIcon field="chauffeur"></p-sortIcon>
								<p-columnFilter type="text" field="chauffeur" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-transport let-expanded="expanded">
					<tr>
						<td>
							<p-button *ngIf="transport.itemsCommandes?.length" type="button" pRipple [pRowToggler]="transport"
								[text]="true" [rounded]="true" [plain]="true"
								[icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></p-button>
						</td>
						<td>
							<span class="font-semibold">{{transport.numero}}</span>
							<i *ngIf="transport.type?.nom == 'Retour'" class="ml-2 pi pi-arrow-left text-blue-500"
								style="font-size: 1rem" pTooltip="Retour"></i>
							<i *ngIf="transport.type?.nom == 'Réquisition'" class="ml-2 pi pi-arrow-right text-green-500"
								style="font-size: 1rem" pTooltip="Réquisition"></i>
							<i *ngIf="transport.type?.nom == 'Transfert'" class="ml-2 pi pi-minus text-orange-500"
								style="font-size: 1rem" pTooltip="Transfert"></i>
						</td>
						<td>{{transport.date | date:'yyyy-MM-dd'}}</td>
						<td>
							<span class="font-medium" [class]="'transport-type-' + (transport.type?.nom?.toLowerCase() || 'default')">
								{{transport.type?.nom}}
							</span>
						</td>
						<td>{{transport.de?.nom}} ({{transport.de?.code}})</td>
						<td>{{transport.a?.nom}} ({{transport.a?.code}})</td>
						<td>
							<app-employe-avec-emplacement [employe]="transport.demandeur"></app-employe-avec-emplacement>
						</td>
						<td>{{transport.camion || '-'}}</td>
						<td>{{transport.remorque || '-'}}</td>
						<td>{{transport.chauffeur || '-'}}</td>
						<td>
							<p-button icon="pi pi-eye" size="small" severity="success" [routerLink]="['/transport', transport.requisitionId]"></p-button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-transport>
					<tr>
						<td [attr.colspan]="11" class="p-0">
							<div class="p-3">
								<p-table [value]="transport.itemsCommandes || []" dataKey="itemCommandeId" styleClass="p-datatable-sm p-datatable-striped">
									<ng-template pTemplate="header">
										<tr>
											<th>Item</th>
											<th>Quantité</th>
											<th>Expéditeur</th>
											<th>Demandeur</th>
											<th>Statut</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-commande>
										<tr>
											<td>{{commande.item?.description || commande.item?.numero || '-'}}</td>
											<td>{{commande.quantite}}</td>
											<td>{{commande.expediteur || '-'}}</td>
											<td>
												<app-employe-avec-emplacement [employe]="commande.demandeur"></app-employe-avec-emplacement>
											</td>
											<td>{{commande.statut?.nom || '-'}}</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="5" class="text-500 p-2">Aucune commande liée à ce transport.</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="11">
							<div class="text-center p-4">
								<i class="pi pi-truck text-4xl text-400 mb-3"></i>
								<p class="text-500">Aucun transport trouvé pour cet emplacement.</p>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</p-card>
	</div>
</div>

<!-- Timeline Section -->
<div id="timeline" *ngIf="EstCharge() && timelineVisible" class="grid">
	<div class="col-12">
		<app-timeline-activite 
			[activites]="activites"
			[config]="timelineConfig"
			[isLoading]="!activitesChargees"
			(onReload)="chargerActivites()"
			(onNavigate)="onTimelineNavigate($event)">
		</app-timeline-activite>
	</div>
</div>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>
		</p-card>
	</div>
</div>